import styled from "styled-components";
import { colors, types } from "../../../libs/themes";

interface HeaderContainerProps {
    padding?: string;
    marginTop?: string;
    marginBottom?: string;
}

interface HeadingProps {
    fontSize?: string;
}

export const HeaderContainer = styled.div.withConfig({
    shouldForwardProp: (prop) =>
        !["padding", "marginTop", "marginBottom"].includes(prop),
}) <HeaderContainerProps>`
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    width: 100%;
    padding: ${({ padding }) => padding || "0"};
    margin-top: ${({ marginTop }) => marginTop || `${types.body.smallTitle}`};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom || `${types.body.smallTitle}`};
`;

export const Heading = styled.div.attrs<HeadingProps>((props) => ({
    style: {
        fontSize: props.fontSize || "42px",
    },
}))`
    font-weight: 700;
    margin: 0;
    word-break: break-word;
    overflow-wrap: break-word;
    min-width: 0;
    flex: 1;
    line-height: normal;
    color: ${({ theme }) => theme.headingColor};
    ${(props) => props.fontSize && `font-size: ${props.fontSize};`}

    span {
        ${types.headers.itemMedium}
        color: ${({ theme }) => theme.headingCountColor};
        margin-left: 8px;
    }
`;

export const SeeAllButton = styled.button<{ isMobile?: boolean }>`
    font-weight: 700 !important;
    font-size: ${({ isMobile }) => (isMobile ? "13px" : "14px")} !important;
    background: transparent;
    border: 1px solid ${({ theme }) => theme.seeAllBorder};
    color: ${({ theme }) => theme.seeAllColor};
    cursor: pointer;
    padding: ${({ isMobile }) => (isMobile ? "6px 8px" : "8px 16px")};
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 6px;

    &:hover {
        background-color: ${({ theme }) => theme.seeAllHover};
    }
`;

interface ToggleButtonProps {
    isSelected: boolean;
}

export const HeaderInlineRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 100%;
    gap: 16px;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 12px;
`;

export const RightControls = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
`;

export const MobileHeaderCenter = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 4px;
`;

export const MobileHeaderLeft = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 70%;
`;

export const MobileHeaderRight = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
`;

export const MobileHeading = styled.div`
    font-weight: 700;
    font-size: 18px;
    line-height: normal;
    margin: 0;
    color: ${({ theme }) => theme.headingColor};
    word-break: break-word;
    overflow-wrap: break-word;
    white-space: normal;
    max-width: 100%;
`;

export const MobileCount = styled.span`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.headingCountColor};
    margin-bottom: 6px;
`;

export const MobileFilterRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    gap: 12px;
    margin-top: 8px;
`;

export const ToggleContainer = styled.div`
    display: flex;
    background: ${colors.background.white};
    border-radius: 12px;
    width: fit-content;
`;

export const ToggleButton = styled.button<ToggleButtonProps>`
    padding: 8px 24px;
    border: none;
    border-radius: 12px;
    background: ${({ isSelected }) =>
        isSelected ? colors.background.grey : "transparent"};
    color: ${({ isSelected }) =>
        isSelected ? colors.text.white : colors.text.black};
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover {
        background: ${({ isSelected }) =>
        isSelected ? colors.background.grey : "#e0e0e0"};
    }
`;
